// extracted by mini-css-extract-plugin
export var actionButton = "_mn-0";
export var actionMenuContainer = "_mn-i";
export var bubble = "_mn-2";
export var bubbleActionMenu = "_mn-j";
export var bubbleContext = "_mn-6";
export var bubbleItems = "_mn-7";
export var customer = "_mn-3";
export var divider = "_mn-8";
export var fileList = "_mn-9";
export var hiddenComment = "_mn-o";
export var infoAbove = "_mn-a";
export var internal = "_mn-4";
export var lightActionButton = "_mn-1";
export var link = "_mn-b";
export var merchant = "_mn-5";
export var message = "_mn-c";
export var profilePicture = "_mn-e";
export var quillToolbarContainer = "_mn-f";
export var senderDate = "_mn-g";
export var senderDateCustomer = "_mn-h";
export var senderName = "_mn-d";
export var time = "_mn-k";
export var uploadedImage = "_mn-l";
export var username = "_mn-m";
export var xsmall = "_mn-n";